import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { LogoMark } from '../icons';

export function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <LogoMark className="h-6 w-6" />
          <span className="text-sm font-semibold text-fg">{t('app.name')}</span>
          <span className="text-sm text-muted">— {t('app.tagline')}</span>
        </div>

        <nav
          aria-label={t('footer.legal')}
          className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm"
        >
          <Link to="/contests" className="text-muted hover:text-fg">
            {t('nav.contests')}
          </Link>
          <Link to="/privacy" className="text-muted hover:text-fg">
            {t('footer.privacy')}
          </Link>
          <Link to="/terms" className="text-muted hover:text-fg">
            {t('footer.terms')}
          </Link>
        </nav>

        <p className="text-xs text-muted">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
}
